<template>
	<tile-card
		:action-title="actionTitle"
		:to="{ name: 'Live Scenes' }"
		:aspect-ratio="3 / 2"
		:disabled="unavailable"
	>
		<div v-if="!loading && items.length === 0" class="body flex-column text-center">
			<v-icon class="flex-grow-1" color="grey lighten-2">fa-running</v-icon>
			<span class="font-italic">{{ emptyText }}</span>
		</div>
		<v-card-text v-else class="grid-container">
			<template v-if="loading">
				<div v-for="i in 6" :key="i">
					<v-responsive aspect-ratio="1">
						<v-skeleton-loader
							type="image"
							:boilerplate="!loading"
							height="100%"
						/>
					</v-responsive>
				</div>
			</template>
			<template v-else>
				<div v-for="item in items" :key="item.guid">
					<SceneWidget :node="item" />
				</div>
			</template>
		</v-card-text>
	</tile-card>
</template>

<style lang="scss" scoped>
.grid-container {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: 1fr 1fr;
	gap: 9px;
	place-items: center stretch;

	::v-deep .v-skeleton-loader__image.v-skeleton-loader__bone {
		height: 100%;
	}

	@media #{map-get($display-breakpoints, 'md-and-up')} {
		gap: 12px;
	}
}
</style>

<script>
import { mapGetters } from "vuex";

import TileCard from "../../shared/TileCard";

import SceneWidget from "./widget/Scene";

export default {
	components: {
		TileCard,
		SceneWidget,
	},

	data: () => ({
		selectedNode: null,
	}),

	computed: {
		...mapGetters({ nodeByGuid: "controller/nodes/nodeByGuid" }),

		loading() {
			return this.$store.getters["controller/connecting"];
		},

		unavailable() {
			return this.$store.getters["controller/state"] < 1;
		},

		items() {
			const allScenes = this.$store.state.scenes.scenes || [];
			return allScenes.filter(this.sceneNotEmpty).slice(0, 6);
		},

		actionTitle() {
			if (this.loading) return "Scenes";
			if (this.unavailable) return false;

			const count = (this.$store.state.scenes.scenes || []).length;
			return `${count} Scenes`;
		},

		emptyText() {
			return this.unavailable
				? "Cannot load scenes. Controller is unavailable."
				: "Have you added any scenes yet?";
		},
	},

	methods: {
		sceneNotEmpty({ hasDate, hasTime, hasEvent, hasCommand } = {}) {
			return hasDate || hasTime || hasEvent || hasCommand;
		},
	},
};
</script>
